export default {
  resetZoom: 'Resetuj powiększenie',
  exitFullscreen: 'Wyjdź z trybu pełnoekranowego',
  fullscreen: 'Pełny ekran',
  showPoints: 'Pokaż punkty',
  showNotes: 'Pokaż notatki',
  showExpertView: 'Pokaż widok eksperta',
  leaveNote: 'Zostaw notatkę (Alt + kliknięcie)',
  zoomMode: 'Tryb powiększenia',
  overFlowMenu: 'Dodatkowe funkcje',
  markersMode: 'Tryb znaczników',
};
